import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageEnum } from '../enum/language';

export const LANGUAGE_PREF_KEY = 'ecklerLanguagePreference';
export const LOGIN_LANGUAGE_KEY = 'ecklerLoginLanguage';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  constructor(private _translate: TranslateService) {}

  applyLanguage(language: LanguageEnum): void {
    const locale = language === LanguageEnum.French ? 'fr_CA' : 'en_CA';
    this._translate.use(locale);
  }

  /** Persists the member's preferred language so it survives sign-out. */
  persistPreference(language: LanguageEnum): void {
    localStorage.setItem(LANGUAGE_PREF_KEY, String(language));
  }

  getPersistedPreference(): LanguageEnum | null {
    const stored = localStorage.getItem(LANGUAGE_PREF_KEY);
    if (stored === null) return null;
    const lang = parseInt(stored, 10);
    if (lang === LanguageEnum.French || lang === LanguageEnum.English) {
      return lang;
    }
    return null;
  }

  log(event: string, details?: Record<string, unknown>): void {
    const ts = new Date().toISOString();
    console.log(`[Language][${ts}] ${event}`, details ?? '');
  }
}
